import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, Link, Typography, Button } from "@mui/material";
import { CallCompanyIcon } from "../../../../../components/icons/CallCompanyIcon/CallCompanyIcon.js";
import { CallIcon } from "../../assets/icons/Call.js";
import { CallFinished } from "../../assets/icons/CallFinished.js";
import { CallInProgress } from "../../assets/icons/CallInProgress.js";
import { CallRinging } from "../../assets/icons/CallRinging.js";
import { CallTaskState, CallTaskActionType } from "../../call-management.types.js";
import { formatEventTime } from "./CallCard.helpers.js";
import { CardWrapper, CardUserDetails, CardHeader, CardNameWrapper, IconWrapper, CardFooter, LastCallbackTime } from "./CallCard.styles.js";
import { CallCardCallbackTime } from "./components/CallCardCallbackTime/CallCardCallbackTime.js";
import { CallCardName } from "./components/CallCardName/CallCardName.js";
import { CallCardStatus } from "./components/CallCardStatus/CallCardStatus.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "date-fns";
import "@mui/material/styles";
import "../../call-management.constants.js";
import "./CallCard.hooks.js";
import "../TimerProvider/index.js";
import "./components/CallCardCallbackTime/CallCardCallbackTime.styles.js";
import "../../assets/icons/Clock.js";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "@mui/system";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "../../../../../components/dialog/dialog.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../components/slider/slider.styles.js";
import "../../../../../components/snackbar/snackbar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "../../../../../components/translations/utils.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "../../../../../components/time-select/time-select.styles.js";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import "@mui/material/Box/index.js";
import "lodash";
import "../../../../components/appointments-picker/appointments-picker.styles.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "clsx";
import "../../../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "../../../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "../../../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "../../../../components/chemistry-info/chemistry-info.styles.js";
import "../../../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../../../components/clinic-location-details/Day/styles.js";
import "../../../../components/clinic-location-details/Map/Map.js";
import "google-map-react";
import "../../../../components/floating-button/floating-button-container/styles.js";
import "../../../../components/floating-button/floating-button.styles.js";
import "../../../../components/news-section/news-section.styles.js";
import "../../../../components/obfuscated-text/obfuscated-text.js";
import "../../../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../../../components/pain-details-form/pain-details-form.styles.js";
import "../../../../components/pain-details-form/constants/constants.js";
import "../../../../components/pain-details-form/types.js";
import "react-slick";
import "../../../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../../../components/task-form/assets/icons/Avatar.js";
import "../../../../components/task-form/assets/icons/Logo.js";
import "../../../../components/task-form/components/Comments/Comments.styles.js";
import "../../../../components/task-form/assets/icons/Comment.js";
import "lodash/debounce.js";
import "../../../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../../../components/task-form/task-form.entities.js";
import "yup";
import "../../../../components/task-form/task-form.helpers.js";
import "date-fns/locale";
import "../../../../components/task-form/task-form.types.js";
import "../../../../components/task-form/task-form.styles.js";
import "../../../../components/task-form/assets/icons/Important.js";
import "../../../../components/task-form/assets/icons/TaskCategory.js";
import "../../../../components/task-form/assets/icons/TaskDescription.js";
import "../../../../components/task-form/assets/icons/TaskName.js";
import "../../../../components/task-form/theme/index.js";
import "../../../../components/task-form/theme/overrides/Button.js";
import "../../../../components/task-form/theme/overrides/PickersLayout.js";
import "../../../../components/task-form/theme/overrides/Menu.js";
import "../../../../components/task-form/theme/overrides/Autocomplete.js";
import "../../../../components/team-section/constants/constants.js";
import "../../../../components/team-section/components/Rating/styles.js";
import "../../../../components/team-section/team-section.styles.js";
import "../../../../components/testimonials-section/constants.js";
import "../../../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../../../components/employee-select/employee-select.js";
import "../../../../../themes/icon-button/icon-button.js";
import "../../../../../themes/tabs/tabs.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../../../components/employee-select/assets/icons/Search.js";
import "../../../../components/employee-select/employee-select.styles.js";
import "../../../../components/employee-select/assets/icons/Arrow.js";
import "../../../../components/employee-select/assets/icons/Employees.js";
import "../../../../components/ana/utils/shared/Checkbox.js";
import "../../../../components/ana/utils/shared/FormControlLabel.js";
import "../../../../components/ana/components/translate/translate.js";
import "../../../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../../../components/ana/components/address-field/address-field.js";
import "formik";
import "../../../../components/ana/utils/helpers/getHasError.js";
import "../../../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../../../components/ana/utils/helpers/googlePlaces.js";
import "../../../../components/ana/utils/helpers/places.js";
import "../../../../components/ana/utils/hooks/useFormHelpers.js";
import "../../../../components/ana/utils/hooks/useSubmitCount.js";
import "../../../../components/ana/utils/shared/TextField.js";
import "../../../../components/ana/utils/shared/TextFieldLabel.js";
import "../../../../components/ana/utils/yup/main.js";
import "../../../../components/ana/utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../../../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../../../components/ana/utils/entities/Form.js";
import "../../../../components/ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "../../../../components/ana/utils/helpers/toBoolean.js";
import "../../../../components/ana/utils/helpers/createFields.js";
import "../../../../components/ana/utils/helpers/resetFields.js";
import "../../../../components/ana/utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../../../components/ana/utils/helpers/predicates.js";
import "../../../../components/ana/utils/yup/emailValidation.js";
import "../../../../components/ana/utils/fields/contactDetails.js";
import "../../../../components/ana/utils/helpers/featureFlags.js";
import "../../../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../../../components/ana/utils/yup/buildValidationSchema.js";
import "../../../../components/ana/utils/fields/miscellaneous.js";
import "../../../../components/ana/utils/fields/insurance.js";
import "../../../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../../../components/ana/utils/config/medicaments.js";
import "../../../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../../../components/ana/utils/fields/consents.js";
import "../../../../components/ana/utils/fields/profileInterest.js";
import "../../../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../../../components/ana/components/date-picker-field/date-picker-field.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "../../../../components/ana/components/phone-field/phone-field.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../../../components/ana/utils/helpers/phoneMetadata.js";
import "../../../../components/ana/components/text-input/text-input.js";
import "../../../../components/ana/components/text-input/text-input.styles.js";
import "../../../../components/ana/components/phone-field/phone-field.styles.js";
import "../../../../components/ana/components/radio-group/radio-group.js";
import "use-deep-compare";
import "../../../../components/ana/utils/shared/Radio.js";
import "../../../../components/ana/utils/shared/RadioFormControl.js";
import "../../../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../../../components/ana/utils/shared/RadioFormLabel.js";
import "../../../../components/ana/utils/shared/RadioGroup.js";
import "../../../../components/ana/components/select-input/select-input.styles.js";
import "../../../../components/ana/components/toggle-field/toggle-field.js";
import "../../../../components/ana/utils/shared/ToggleContainer.js";
import "../../../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../../../components/ana/utils/hooks/useFormValue.js";
import "../../../../components/ana/components/form-layout/form-layout.styles.js";
import "../../../../components/ana/utils/shared/Button.js";
import "../../../../components/ana/components/submit-button/submit-button.styles.js";
import "../../../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../../../components/ana/utils/config/diseases.js";
import "../../../../components/ana/components/insurance-field/insurance-field.js";
import "fuse.js";
import "../../../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../../../components/ana/utils/shared/SectionTitle.js";
import "../../../../components/ana/components/callout/Callout.styles.js";
import "../../../../components/ana/utils/types/contentful.js";
import "../../../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../../../components/ana/utils/helpers/getIsRequired.js";
import "../../../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../../../components/ana/components/form-layout/form-layout.js";
import "../../../../components/ana/utils/helpers/createField.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../../../components/ana/components/select-field/select-field.js";
import "../../../../components/ana/components/select-input/select-input.js";
import "../../../../components/ana/components/text-field/text-field.js";
import "../../../../components/ana/components/submit-button/submit-button.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "../../../../../components/loader/loader.styles.js";
import "../../../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../../../components/ana/utils/config/wishes.js";
import "../../../../components/ana/forms/preconditions/preconditions.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../../../components/ana/utils/helpers/DiseaseType.js";
import "../../../../components/ana/components/disease-field/disease-field.js";
import "../../../../components/ana/components/tag/tag.js";
import "../../../../components/ana/components/tag/tag.styles.js";
import "@mui/icons-material/Cancel.js";
import "../../../../components/ana/components/disease-field/disease-field.styles.js";
import "@mui/styles";
import "../../../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../../../components/ana/utils/helpers/isInViewport.js";
import "../../../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../../../components/ana/utils/shared/Modal.js";
import "../../../../components/ana/utils/helpers/i18n.js";
import "../../../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../../../components/website/common/button/styles.js";
import "../../../../components/website/jobs/job-description-section/styles.js";
import "../../../../components/website/jobs/job-details-hero-section/styles.js";
import "../../../../components/website/common/button/button.js";
import "../../../../../hooks/useResponsive.js";
import "../../../../components/smileview-section/hooks/useWindowSize.js";
import "../../../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../../../components/page-header/context/header-context.js";
import "../../../../components/page-header/components/header-skip/styles.js";
import "../../../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../../../components/authentication/components/CredentialsProvider.js";
import "../../../../components/authentication/config.js";
import "../../../../components/authentication/helpers/time.js";
import "../../../../components/authentication/hooks/useStickyState.js";
import "../../../../components/authentication/services/api.js";
import "axios";
import "../../../../components/authentication/helpers/credentials.js";
import "../../../../components/authentication/helpers/headers.js";
import "../../../../components/authentication/components/RouterProvider.js";
import "../../../../components/authentication/components/SecurityConfigProvider.js";
import "../../../../components/authentication/services/i18n.js";
import "../../../../components/authentication/components/auth-container/auth-container.styles.js";
import "@emotion/styled";
import "../../../../components/authentication/components/login-page/login-page.styles.js";
import "../../../../components/authentication/components/TrustedDeviceProvider.js";
import "../../../../components/authentication/components/HistoryProvider.js";
import "../../assets/icons/ExpandArrow.js";
import "../../assets/icons/User.js";
import "./components/CallCardName/CallCardName.styles.js";
import "../../assets/icons/CallActive.js";
import "../../assets/icons/CallIgnored.js";
import "../../assets/icons/CallOpen.js";
import "./components/CallCardIgnoreForm/CallCardIgnoreForm.js";
import "./components/CallCardIgnoreForm/CallCardIgnoreForm.helpers.js";
import "react-hook-form";
import "./components/CallCardIgnoreForm/CallCardIgnoreForm.styles.js";
import "./components/CallCardVoicemail/CallCardVoicemail.js";
import "../../assets/icons/Voicemail.js";
import "./components/CallCardVoicemail/CallCardVoicemail.styles.js";
import "./components/CallCardStatus/CallCardStatus.styles.js";
import "../../assets/icons/Info.js";
const getStatusIcon = (status) => {
  switch (status) {
    case CallTaskState.Open_Ringing:
      return CallRinging;
    case CallTaskState.Done:
    case CallTaskState.Done_AvailyBooking:
      return CallFinished;
    case CallTaskState.Open_InProgress:
      return CallInProgress;
    default:
      return CallIcon;
  }
};
const OPEN_STATE = [CallTaskState.Open, CallTaskState.Open_UnsuccessfulCallback];
const getPatientNumber = (data) => {
  var _a, _b;
  const incomingCalls = data.incomingCallSize;
  const incomingCallsInfo = incomingCalls > 1 ? `(${incomingCalls})` : "";
  const showPatientNumber = !!((_b = (_a = data.caller) == null ? void 0 : _a.patients) == null ? void 0 : _b.length);
  if (!showPatientNumber)
    return null;
  return `${data.caller.phoneNumber} ${incomingCallsInfo}`;
};
const CallCard = ({
  data,
  isActive,
  phones = [],
  onIgnore,
  onVoicemailSelect,
  onNewAppointmentClick,
  onTriggerCall,
  labels,
  onClick,
  isObfuscated,
  smartVoiceRecorderLink
}) => {
  var _a, _b;
  const status = data.currentState;
  const isCallOpen = OPEN_STATE.some((currentState) => currentState === status);
  const patientNumber = getPatientNumber(data);
  const showAppointmentButton = status === CallTaskState.Open_InProgress && !patientNumber && !!onNewAppointmentClick;
  const callTime = formatEventTime(data == null ? void 0 : data.latestIncomingCallAt, labels);
  const StatusIcon = useMemo(() => getStatusIcon(status), [status]);
  const handleVoicemailSelect = (phone) => {
    onVoicemailSelect({
      phone,
      taskReferenceId: data.referenceId
    });
  };
  const handleCallSelect = (phone) => {
    var _a2, _b2, _c, _d;
    onTriggerCall({
      phone,
      phoneNumber: (_a2 = data.caller) == null ? void 0 : _a2.phoneNumber,
      taskReferenceId: data.referenceId,
      patientReferenceId: (_d = (_c = (_b2 = data.caller) == null ? void 0 : _b2.patients) == null ? void 0 : _c[0]) == null ? void 0 : _d.referenceId
    });
  };
  const handleNewAppointment = (event) => {
    event.stopPropagation();
    onNewAppointmentClick == null ? void 0 : onNewAppointmentClick(data);
  };
  const handlePatientNameClick = (referenceId, externalId) => {
    if (referenceId && onClick)
      onClick(referenceId, externalId);
  };
  const handleIgnore = ({ comment }) => {
    onIgnore({
      data: {
        comment,
        type: CallTaskActionType.Ignore
      },
      taskReferenceId: data.referenceId
    });
  };
  return /* @__PURE__ */ jsxs(CardWrapper, { status, isActive, children: [
    /* @__PURE__ */ jsxs(CardUserDetails, { children: [
      /* @__PURE__ */ jsxs(CardHeader, { children: [
        /* @__PURE__ */ jsxs(CardNameWrapper, { children: [
          /* @__PURE__ */ jsx(IconWrapper, { status, isActive, children: /* @__PURE__ */ jsx(StatusIcon, {}) }),
          /* @__PURE__ */ jsx(
            CallCardName,
            {
              data,
              onClick: handlePatientNameClick,
              labels: labels.name,
              isObfuscated
            }
          )
        ] }),
        smartVoiceRecorderLink ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Box, { sx: { display: "inline-flex", flexDirection: "column", gap: 1, alignItems: "end" }, children: [
          /* @__PURE__ */ jsx(
            CallCardStatus,
            {
              status,
              comment: (_a = data.action) == null ? void 0 : _a.comment,
              isActive: isActive || false,
              isOpen: isCallOpen,
              phones,
              onIgnore: handleIgnore,
              onVoicemailSelect: handleVoicemailSelect,
              hasVoicemail: data.hasAnsweringMachineRecordings,
              onSelect: handleCallSelect,
              labels: labels.status
            }
          ),
          /* @__PURE__ */ jsx(Link, { href: smartVoiceRecorderLink, children: /* @__PURE__ */ jsx(CallCompanyIcon, {}) })
        ] }) }) : /* @__PURE__ */ jsx(
          CallCardStatus,
          {
            status,
            comment: (_b = data.action) == null ? void 0 : _b.comment,
            isActive: isActive || false,
            isOpen: isCallOpen,
            phones,
            onIgnore: handleIgnore,
            onVoicemailSelect: handleVoicemailSelect,
            hasVoicemail: data.hasAnsweringMachineRecordings,
            onSelect: handleCallSelect,
            labels: labels.status
          }
        )
      ] }),
      patientNumber && /* @__PURE__ */ jsx(Box, { mt: 0.5, children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 2", children: patientNumber }) })
    ] }),
    /* @__PURE__ */ jsxs(CardFooter, { showButton: showAppointmentButton, children: [
      !showAppointmentButton && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(LastCallbackTime, { variant: "Lato Caption", children: callTime }),
        /* @__PURE__ */ jsx(CallCardCallbackTime, { data, labels: labels.callbackTime })
      ] }),
      showAppointmentButton && /* @__PURE__ */ jsx(Button, { onClick: handleNewAppointment, size: "xs", children: labels.newAppointment })
    ] })
  ] });
};
export {
  CallCard
};
